"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _button = _interopRequireDefault(require("@ux/button"));
var _search = _interopRequireDefault(require("@ux/icon/search"));
var _VoiceSearchButton = _interopRequireDefault(require("./VoiceSearchButton"));
var _uxUtils = require("@site/ux-utils");
var _utils = require("@site/utils");
const SearchButtons = ({
  disableSearch,
  voiceSearchProps,
  buttonDivClassname,
  styling,
  hideIcon,
  icon,
  buttonText,
  ariaLabels,
  updateAutoCompleteState,
  setShowCustomSuggestions,
  logEvent,
  onSearch,
  query,
  buttonEids,
  overlayEnabled,
  isDropDownOpen,
  market
}) => {
  const onClickSearchButton = () => {
    updateAutoCompleteState(false);
    setShowCustomSuggestions(false);
    logEvent({
      eid: buttonEids.searchEid,
      type: 'click'
    });
    onSearch(query);
  };
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  const shouldShowVoiceSearchButton = () => {
    // see MDN API Speech Recognition docs for updated browswer support info
    const supportedBrowsers = ['chrome', 'safari', 'edge', 'samsung'];
    const showVoiceSearch = voiceSearchProps?.useVoiceSearch && (0, _utils.getIsBrowserSupported)(supportedBrowsers);
    return showVoiceSearch;
  };
  const showVoiceSearch = shouldShowVoiceSearchButton();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "search-buttons-div d-flex align-items-center"
  }, showVoiceSearch && /*#__PURE__*/_react.default.createElement(_VoiceSearchButton.default, {
    voiceSearchProps: voiceSearchProps,
    disableSearch: disableSearch,
    onSearch: onSearch,
    setShowCustomSuggestions: setShowCustomSuggestions,
    isMobile: isMobile,
    overlayEnabled: overlayEnabled,
    isDropDownOpen: isDropDownOpen,
    buttonClassnames: buttonDivClassname,
    voiceToTextEid: buttonEids.voiceToTextEid,
    voiceToTextErrorEid: buttonEids.voiceToTextErrorEid,
    speechRecognitionErrorEid: buttonEids.SpeechRecognitionApiError,
    market: market
  }), /*#__PURE__*/_react.default.createElement(_button.default, {
    id: "domain-search-box-button",
    "data-testid": "domain-search-box-button",
    design: "primary",
    icon: !hideIcon && (icon || /*#__PURE__*/_react.default.createElement(_search.default, {
      fill: styling?.buttonIconColor || 'currentColor'
    })),
    text: buttonText,
    "aria-label": ariaLabels.searchButton,
    onClick: onClickSearchButton,
    disabled: disableSearch,
    className: (0, _classnames.default)(buttonDivClassname, {
      'search-max-zindex': overlayEnabled && isDropDownOpen,
      'pr-1 pl-1 ': showVoiceSearch && isMobile,
      'pr-3 pl-3 ': !(showVoiceSearch && isMobile)
    })
  }));
};
SearchButtons.propTypes = {
  overlayEnabled: _propTypes.default.bool,
  isDropDownOpen: _propTypes.default.bool,
  hideIcon: _propTypes.default.bool,
  icon: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.elementType]),
  styling: _propTypes.default.shape({
    buttonRadius: _propTypes.default.string,
    buttonColor: _propTypes.default.string,
    buttonIconColor: _propTypes.default.string,
    buttonBorder: _propTypes.default.string,
    buttonMargin: _propTypes.default.string
  }),
  buttonText: _propTypes.default.string,
  ariaLabels: _propTypes.default.shape({
    searchLabel: _propTypes.default.string,
    searchButton: _propTypes.default.string
  }),
  updateAutoCompleteState: _propTypes.default.func,
  setShowCustomSuggestions: _propTypes.default.func,
  logEvent: _propTypes.default.func,
  onSearch: _propTypes.default.func,
  query: _propTypes.default.string,
  searchEid: _propTypes.default.string,
  handleAudioRecordClick: _propTypes.default.func,
  disableSearch: _propTypes.default.bool,
  voiceSearchProps: _propTypes.default.shape({
    useVoiceSearch: _propTypes.default.bool,
    voiceButtonText: _propTypes.default.string,
    voiceTooltipText: _propTypes.default.string,
    voiceButtonStyling: _propTypes.default.shape({
      buttonColor: _propTypes.default.string,
      buttonIconColor: _propTypes.default.string,
      buttonBorder: _propTypes.default.string,
      buttonDesign: _propTypes.default.string,
      buttonColorHover: _propTypes.default.string
    })
  })
};
var _default = exports.default = SearchButtons;